import React, { Component } from "react";
import SurveyItems from "components/SurveyItems";
import { connect } from "react-redux";
import { track, trackPage } from "analytics";
import { Helmet } from "react-helmet";
import {
  updateSurveyQuestions,
  clearCurrentSurveyId,
  updateSurveyRedux,
  getUser,
  setPageTitle,
  deploySurvey,
  startLoading,
  clearSurveyDurationEstimate,
  getSurvey,
  getPublishedSurvey,
  getDrafts,
  getSurveyQuestions,
} from "redux/actions";
import CreateFromDraft from "components/SurveyTemplates/CreateFromDraft";
import TemplateSurveyPopup from "components/Popups/TemplateSurveyPopup";
import Templates from "components/SurveyTemplates/Templates";
import SurveySettings from "views/CreateSurvey/SurveySettings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faEye,
  faCog,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import {
  Tabs,
  Tab,
  Breadcrumbs,
  Link,
  Grid,
  Button,
  CircularProgress,
  Paper,
} from "@material-ui/core";
import SurveyAppearance from "views/CreateSurvey/SurveyAppearance";
import {
  getBlankSurvey,
  getBlankQuestion,
  getBlankQuestionGroup,
} from "utils/defaults";
import { sleep, notification, blockFreeTier, getFrontEndBaseUrl } from "utils/utils";
import { ClipLoader, ScaleLoader } from "react-spinners";
import _ from "lodash";
import clsx from "clsx";
import QuestionConfiguration from "views/CreateSurvey/QuestionConfiguration";
import PreviewSettings from "components/SurveyCreation/PreviewSettings";
import ConfirmationPopup from "components/Popups/ConfirmationPopup";
import EmbedPreview from "components/EmbedPreview";
import { FocusStates } from "utils/data";
import { getObjectId } from "utils/utils";
import { truncateStringWithEllipsis } from "utils/utils";
import { questionsEqual, objectsEqual } from "utils/surveyComparison";
import { getEmbedJSX, isAudioType } from "utils/utils";

const mapStateToProps = (state) => {
  return {
    createSurveyId: state.createSurveyId,
    currentSurvey: state.currentSurvey,
    publishedSurvey: state.publishedSurvey,
    user: state.user,
    loading: state.loading["CreateSurvey"],
    estimatedCompletionTimeMinutes: state.estimatedCompletionTimeMinutes,
    drafts: state.drafts,
  };
};

const mapDispatchToProps = {
  updateSurveyQuestions,
  getSurvey,
  getPublishedSurvey,
  clearCurrentSurveyId,
  updateSurveyRedux,
  getUser,
  setPageTitle,
  deploySurvey,
  startLoading,
  clearSurveyDurationEstimate,
  getDrafts,
  getSurveyQuestions,
};

const tabOptions = ["questions", "appearance", "admin"];
const previewOptions = ["default", "popover", "sidedrawer", "inline"];

let BASE_URL = getFrontEndBaseUrl()

class CreateSurvey extends Component {
  constructor(props) {
    super(props);
    trackPage("Survey Builder [V2]");

    this.state = {
      info: { ...getBlankSurvey() },
      showPopup: true,
      confirmationPopup: false,
      tab: "questions",
      previewId: 0,
      previewQuestionIdx: undefined,
      isQuestionConfigOpen: false,
      publishPending: undefined,
      isTemplate: true,
      selectedQuestionId: undefined,
      questionFocusOverride: FocusStates.NONE,
      popupOptions: {
        mainView: true,
        isTemplates: true,
        createSurveyFocus: null,
      },
      autoRefresh: true,
      preview: "default",
      unpublishedChanges: false,
    };

    if (this.props.match.params.surveyId) {
      this.props.getSurvey(this.props.match.params.surveyId, { staging: true });
      this.props.getPublishedSurvey(this.props.match.params.surveyId);
      this.state = {
        ...this.state,
        showPopup: false,
        surveyId: this.props.match.params.surveyId,
      };
    } else {
      this.state = {
        ...this.state,
        showPopup: true,
        surveyId: this.props.match.params.surveyId,
      };
    }
  }

  componentWillUnmount() {
    this.props.clearCurrentSurveyId();
    this.props.getUser();
    this.props.clearSurveyDurationEstimate();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.info !== prevState.info ||
      prevProps.publishedSurvey !== this.props.publishedSurvey
    )
      this.setState({
        unpublishedChanges: this.hasUnpublishedChanges(),
      });
    if (
      prevProps.currentSurvey !== this.props.currentSurvey &&
      this.props.currentSurvey
    ) {
      var questions = this.props.currentSurvey.questions;
      // Merging Fixed and Options into objects
      // TODO: database migration + survey app changes
      if (
        questions.length > 0 &&
        questions[0].options &&
        questions[0].options.length > 0 &&
        typeof questions[0].options[0] === "string"
      ) {
        if (questions[0].fixed) {
          questions.map((q) => {
            return (q.options = q.options.map((o, oidx) => {
              return {
                text: o,
                fixed: q.fixed[oidx],
                skip: q.optionProps?.[oidx]?.skip ?? 0,
                mutuallyExclusive: q.optionProps?.[oidx]?.mutuallyExclusive ?? false,
              };
            }));
          });
        } else {
          questions.map((q) => {
            q.options = q.options.map((o, oidx) => ({ text: o, fixed: false, skip: q.optionProps?.[oidx]?.skip ?? 0, mutuallyExclusive: false }));
            return null;
          });
        }
        // If new props have been added to the question prototype, merge them
        // into the existing question object with their default values
        this.props.currentSurvey.questions = questions.map((q) => {
          const qWithDefaults = { ...getBlankQuestion(), ...q }
          // apply exceptions for when missing props is different from default value
          if (typeof q.showSelectionIcons === 'undefined') {
            qWithDefaults.showSelectionIcons = true;
          }
          return qWithDefaults
        });
      }
      this.setState(
        {
          ...this.state,
          info: { ...this.state.info, ...this.props.currentSurvey },
        },
        () => {
          // Save new changes to mongo if not new survey
          if (prevProps.currentSurvey) {
            this.onSaveStay(() =>
              this.setState({ previewId: this.state.previewId + 1 })
            );
          }
        }
      );
    }
    this.props.setPageTitle(
      <div className="breadcrumbs-title">
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit">Survey Builder</Link>
          {this.state.info.name && (
            <Link color="inherit">
              {truncateStringWithEllipsis(this.state.info.name, 36)}
            </Link>
          )}
        </Breadcrumbs>
      </div>
    );
  }

  hasUnpublishedChanges = () => {
    if (
      this.props.publishedSurvey === undefined ||
      this.props.publishedSurvey === null ||
      this.state.info === undefined ||
      this.props.publishedSurvey.state === "DRAFT"
    )
      return false;

    const surveyQuestionsEqual = questionsEqual(
      this.state.info.questions,
      this.props.publishedSurvey.questions
    );

    const surveySettingsEqual = objectsEqual(
      this.state.info,
      this.props.publishedSurvey,
      ["createdAt", "state", "persistResponses", "questions"]
    );

    return !(surveySettingsEqual && surveyQuestionsEqual);
  };

  getQuestionIdx = (id) => {
    /* The welcome screen uses a questionId of undefined */
    if (id === undefined) return undefined;

    const index = this.state.info.questions.findIndex(
      (question) => question.questionId === id
    );
    return index === -1 ? undefined : index;
  };

  changeQInfo = (qinfo, id, refreshPreview) => {
    var questions = _.cloneDeep(this.state.info.questions);
    const idx = this.getQuestionIdx(id);
    if (idx === undefined) return;

    if (isAudioType(questions[idx].type) && !isAudioType(qinfo.type)) {
      qinfo.startRecording = false;
    }
    
    questions[idx] = qinfo;
    this.setState(
      {
        info: {
          ...this.state.info,
          questions: questions,
        },
      },
      () => {
        this.onSaveStay(() => {
          if (refreshPreview) {
            this.previewQuestion(id, refreshPreview);
          }
        });
      }
    );
  };

  updateQuestionGroup = (questionGroup, id, refreshPreview) => {
    if (questionGroup.id === undefined) return;
    this.setState(
      {
        info: {
          ...this.state.info,
          questionGroups: {
            ...this.state.info.questionGroups,
            [questionGroup.id]: questionGroup,
          },
        },
      },
      () => {
        this.onSaveStay(() => {
          if (refreshPreview) {
            this.previewQuestion(id, refreshPreview);
          }
        });
      }
    );
  };

  checkQuestionLimit = (length) => {
    // Free tier restricts at 10 questions
    if (!this.props.user) return;
    if (
      this.props.user.tier !== "STARTER" &&
      this.props.user.tier !== "PREMIUM" &&
      this.props.user.tier !== "ENTERPRISE" &&
      length >= 10
    ) {
      notification(
        "Too many questions.",
        "Please upgrade to Premium to add more than ten questions to your survey.",
        "info"
      );
      return false;
    }
    return true;
  };

  addQuestionGroup = (idx, type) => {
    track(`[Builder V2] Adding Question Group: ${type}`, {
      surveyId: this.state.info._id,
    });
    const newQuestionGroup = getBlankQuestionGroup();
    newQuestionGroup.type = type;
    this.setState(
      {
        info: {
          ...this.state.info,
          questionGroups: {
            ...this.state.info.questionGroups,
            [newQuestionGroup.id]: newQuestionGroup,
          },
        },
      },
      () => this.addQuestion(idx, "SCREEN", newQuestionGroup.id)
    );
  };

  removeQuestionGroupIfNeeded = async (groupId) => {
    if (groupId === undefined) return;
    const questionsInGroup = this.state.info.questions.filter(
      (question) => question.groupId === groupId
    );
    if (questionsInGroup.length > 0) return;

    let questionGroups = _.cloneDeep(this.state.info.questionGroups);
    delete questionGroups[groupId];
    await this.setState({
      info: {
        ...this.state.info,
        questionGroups: questionGroups,
      },
    });
  };

  removeQuestionFromGroup = (groupId) => {
    if (groupId === undefined) return;
    const questionGroup = this.state.info.questionGroups[groupId];
    if (questionGroup.numQuestions <= 1) {
      let questionGroups = _.cloneDeep(this.state.info.questionGroups);
      delete questionGroups[groupId];
      this.setState({
        info: {
          ...this.state.info,
          questionGroups: questionGroups,
        },
      });
    } else
      this.setState({
        info: {
          ...this.state.info,
          questionGroups: {
            ...this.state.info.questionGroups,
            [groupId]: {
              ...questionGroup,
              numQuestions: questionGroup.numQuestions - 1,
            },
          },
        },
      });
  };

  addQuestion = (idx = undefined, type = undefined, groupId = undefined) => {
    track(`[Builder V2] Adding Question: ${type}`, {
      surveyId: this.state.info._id,
    });
    let questions = _.cloneDeep(this.state.info.questions);
    if (!this.checkQuestionLimit(questions.length)) return;
    idx = idx ? idx : questions.length;
    let newQuestion = { ...getBlankQuestion(), newQuestion: true };
    let questionGroups = this.state.info.questionGroups;
    if (groupId !== undefined) {
      newQuestion.groupId = groupId;
    }
    if (type !== undefined) newQuestion.type = type;
    questions.splice(idx, 0, newQuestion);
    this.setState(
      {
        info: {
          ...this.state.info,
          questions: questions,
          questionGroups: questionGroups,
        },
        /* Focus the input field of the new question */
        selectedQuestionId: newQuestion.questionId,
        questionFocusOverride: FocusStates.SET_FOCUS,
      },
      () => {
        this.onSaveStay(() => {
          this.previewQuestion(newQuestion.questionId, true);
        });
      }
    );
  };

  duplicateQuestion = (idx) => {
    var questions = _.cloneDeep(this.state.info.questions);
    if (!this.checkQuestionLimit(questions.length)) return;

    /* Duplicate question is inserted into the array at the index immediately
     * following the source question */
    const newQuestionId = getObjectId();
    questions.splice(idx + 1, 0, {
      ..._.cloneDeep(questions[idx]),
      questionId: newQuestionId,
    });
    let questionGroups = this.state.info.questionGroups;

    this.setState(
      {
        info: {
          ...this.state.info,
          questions: questions,
          questionGroups: questionGroups,
        },
        /* Focus the input field of the new question */
        selectedQuestionId: newQuestionId,
        questionFocusOverride: FocusStates.SET_FOCUS,
      },
      /* Push the survey to the backend and render the new question */
      () => {
        this.onSaveStay(() => {
          this.previewQuestion(newQuestionId, true);
        });
      }
    );
  };
  removeQuestion = (idx) => {
    /* After removing the question, render the actively selected question (if
     * available) or the question immediately before the removed question */
    const removeId = this.state.info.questions[idx].questionId;
    const removedQuestionGroupId = this.state.info.questions[idx].groupId;
    let renderId = this.state.selectedQuestionId;

    if (renderId === removeId || renderId === undefined) {
      const renderIdx = idx !== 0 ? idx - 1 : 1;
      renderId =
        renderIdx < this.state.info.questions.length
          ? this.state.info.questions[renderIdx].questionId
          : undefined;
    }

    this.setState(
      (prevState) => {
        var questions = _.cloneDeep(prevState.info.questions);
        questions.splice(idx, 1);
        return {
          ...prevState,
          info: {
            ...prevState.info,
            questions: questions,
          },
          /* Remove focus from all components */
          selectedQuestionId: renderId,
          questionFocusOverride: FocusStates.BLUR_ALL,
        };
      },
      async () => {
        await this.removeQuestionGroupIfNeeded(removedQuestionGroupId);
        this.onSaveStay(() => {
          this.previewQuestion(renderId, true);
        });
      }
    );
  };
  onSubmit = () => {
    this.setState({ publishPending: true });
    this.props.deploySurvey(this.state.info._id);
    // Quick timeout to make sure survey changes propagate
    sleep(100).then(() => {
      this.setState(
        { publishPending: false },
        this.props.history.push(`/surveys`)
      );
    });
  };
  onSaveStay = (callback) => {
    const questions = this.state.info.questions.map((q) => {
      var options = [],
        fixed = [];
      q.options.forEach((o) => {
        options.push(o.text);
        fixed.push(o.fixed);
      });
      var newQ = { ...q, newQuestion: undefined };
      newQ.options = options;
      newQ.fixed = fixed;
      newQ.optionProps = q.options;
      return newQ;
    });
    const surveyQuestions = {
      ...this.state.info,
      questions: questions,
    };
    this.props.startLoading(
      () =>
        this.props.updateSurveyQuestions(
          this.state.surveyId,
          surveyQuestions,
          callback
        ),
      "CreateSurvey"
    );
  };

  previewQuestion = (id, forceRender = false) => {
    this.setState((state) => {
      /* Preview window requires indices not identifiers */
      const previewIdx = this.getQuestionIdx(id);
      return {
        selectedQuestionId: id,
        previewQuestionIdx: previewIdx,
        questionFocusOverride: FocusStates.NONE,
        ...(forceRender &&
          this.state.autoRefresh && { previewId: state.previewId + 1 }),
        /* Close question config panel if welcome screen is selected */
        ...(!id && { isQuestionConfigOpen: false }),
      };
    });
  };

  addQuestionOption = (q_idx, idx, numOptions = 1) => {
    let question = _.cloneDeep(this.state.info.questions[q_idx]);
    let blankOptions = [];
    for (let i = 0; i < numOptions; i++) {
      blankOptions.push({
        text: "",
        fixed: false,
        skip: 0,
        mutuallyExclusive: false,
      });
    }
    if (idx + 1 === question.options.length)
      question.options = [...question.options, ...blankOptions];
    else
      question.options = [
        ...question.options.slice(0, idx + 1),
        ...blankOptions,
        ...question.options.slice(idx + 1),
      ];
    this.setState({
      info: {
        ...this.state.info,
        questions: [
          ...this.state.info.questions.slice(0, q_idx),
          question,
          ...this.state.info.questions.slice(q_idx + 1),
        ],
      },
    });
  };
  removeQuestionOption = (q_idx, o_idx) => {
    var questions = this.state.info.questions;
    questions[q_idx].options.splice(o_idx, 1);
    this.setState({
      info: {
        ...this.state.info,
        questions: questions,
      },
    });
  };
  moveQuestionOptionUp = (q_idx, idx) => {
    if (idx === 0) return;
    var questions = this.state.info.questions;
    const option = questions[q_idx].options[idx];
    questions[q_idx].options.splice(idx, 1);
    questions[q_idx].options.splice(idx - 1, 0, option);
    this.setState({
      info: {
        ...this.state.info,
        questions: questions,
      },
    });
  };
  moveQuestionOptionDown = (q_idx, idx) => {
    if (idx === this.state.info.questions[q_idx].options.length - 1) return;
    var questions = this.state.info.questions;
    const option = questions[q_idx].options[idx + 1];
    questions[q_idx].options.splice(idx + 1, 1);
    questions[q_idx].options.splice(idx, 0, option);
    this.setState({
      info: {
        ...this.state.info,
        questions: questions,
      },
    });
  };

  changeDemo = (e, demo) => {
    this.setState(
      {
        info: {
          ...this.state.info,
          demographics: {
            ...this.state.info.demographics,
            [demo]: e.target.checked,
          },
        },
      },
      () => {
        this.onSaveStay(() => {
          this.setState({ previewId: this.state.previewId + 1 });
        });
      }
    );
  };
  nextTab = () => {
    this.setState({
      tab: tabOptions[
        (tabOptions.indexOf(this.state.tab) + 1) % tabOptions.length
      ],
    });
  };
  changeInfo = (info, refreshPreview) => {
    this.setState(
      {
        info: { ...this.state.info, ...info },
      },
      () => {
        // Only save if refreshPreview is not explicitly false
        if (refreshPreview !== false) {
          this.onSaveStay(() => {
            if (refreshPreview) {
              this.setState({
                previewId: this.state.previewId + 1,
                previewQuestionIdx: this.getQuestionIdx(
                  this.state.selectedQuestionId
                ),
              });
            }
          });
        }
      }
    );
  };

  openQuestionConfig = () => {
    this.setState({ isQuestionConfigOpen: true });
  };

  closeQuestionConfig = () => {
    this.setState({ isQuestionConfigOpen: false });
  };

  showPreview = () => {
    track("[Builder V2] Opening Preview");
    var url = new URL(`${BASE_URL}/${this.state.surveyId}`);
    if (this.state.info.state !== "DRAFT")
      url.searchParams.set("preview", true);
    url.searchParams.set("staging", true);
    window.open(url, "_blank");
  };

  changeTabs = (e, v) => {
    track(`[Builder V2] Changing Tabs: ${v}`);
    this.setState({
      tab: v,
    });
  };
  pushSurveyUpdates = () => {
    this.props.updateSurveyRedux(this.state.info);
  };

  templateSurveySwitch = (createNewOrContinue) => {
    this.setState({
      ...this.state,
      popupOptions: {
        isTemplate: false,
        mainView: false,
        createSurveyFocus: createNewOrContinue,
      },
    });
  };

  turnOffMainView = () => {
    this.setState({
      popupOptions: { ...this.state.popupOptions, mainView: false },
    });
  };

  formatDurationString = () => {
    const times = this.props.estimatedCompletionTimeMinutes;

    if (times.upperBound !== times.lowerBound) {
      return `${times.lowerBound} - ${times.upperBound} min`;
    } else {
      return `${times.lowerBound} min`;
    }
  };

  toggleAutoRefresh = (autoRefreshOn) => {
    this.setState({
      previewId: this.state.previewId + 1,
      autoRefresh: autoRefreshOn,
    });
  };

  setPreview = (option) => {
    this.setState({ preview: option });
  };

  /**
   * Function to update a question's options.
   * @param {*} question The full question to modify.
   * @param {*} optionIdx The option index to modify.
   * @param {*} info The properties to coalesce with the current option.
   */
  changeQuestionOption = (question, optionIdx, info) => {
    var options = question.options;
    options[optionIdx] = { ...options[optionIdx], ...info };
    const qinfo = {
      ...question,
      options: options,
    };
    this.changeQInfo(qinfo, question.questionId);
  };

  exportQuestions = () => {
    // Reject if the user is not premium
    if (blockFreeTier(this.props.user)) return;
    this.props
      .getSurveyQuestions(this.props.match.params.surveyId)
      .then((res) => {
        try {
          var hiddenElement = document.createElement("a");
          var blob = new Blob([res], {
            type: "text/csv",
          });
          var url = window.URL.createObjectURL(blob);
          hiddenElement.href = url;

          hiddenElement.target = "_blank";
          hiddenElement.download = `phonic-${
            this.props.match.params.surveyId
          }.${"csv"}`;
          hiddenElement.click();
        } catch (e) {
          alert("Unable to Export. Try again later.");
        }
      });
  };

  modFunctions = {
    changeQInfo: this.changeQInfo,
    changeInfo: this.changeInfo,
    addQuestion: this.addQuestion,
    addQuestionGroup: this.addQuestionGroup,
    removeQuestion: this.removeQuestion,
    addQuestionOption: this.addQuestionOption,
    removeQuestionOption: this.removeQuestionOption,
    moveQuestionOptionUp: this.moveQuestionOptionUp,
    moveQuestionOptionDown: this.moveQuestionOptionDown,
    pushSurveyUpdates: this.pushSurveyUpdates,
    duplicateQuestion: this.duplicateQuestion,
    openQuestionConfig: this.openQuestionConfig,
    closeQuestionConfig: this.closeQuestionConfig,
    previewQuestion: this.previewQuestion,
    updateQuestionGroup: this.updateQuestionGroup,
    changeQuestionOption: this.changeQuestionOption,
  };

  render() {
    const settingsClass = this.state.tab === "admin" ? "" : "display-none";
    const questionsClass = this.state.tab === "questions" ? "" : "display-none";
    const appearanceClass =
      this.state.tab === "appearance" ? "" : "display-none";
    const editorClass =
      this.state.tab === "appearance" || this.state.tab === "questions"
        ? ""
        : "display-none";

    const selectedQuestion = this.state.info.questions.find((question) => {
      return question.questionId === this.state.selectedQuestionId;
    });
    const showConfigPane = selectedQuestion && this.state.isQuestionConfigOpen;

    return (
      <>
        <Helmet>
          <title>Create Survey</title>
        </Helmet>
        <div id="survey-builder">
          {this.state.showPopup && (
            <TemplateSurveyPopup
              open={this.state.showPopup}
              handleClose={() => this.props.history.push("/surveys")}
              templateSurveySwitch={() =>
                this.setState({ isTemplate: !this.state.isTemplate })
              }
              isTemplate={this.state.isTemplate}
              backToMainView={() => {
                this.setState({
                  popupOptions: {
                    mainView: true,
                    isTemplates: true,
                    createSurveyFocus: null,
                  },
                });
              }}
              isMainView={this.state.popupOptions.mainView}
              filterTemplates={(key) => {
                this.setState({ searchKey: key });
              }}
            >
              {this.state.popupOptions.isTemplates ? (
                <Templates
                  isMainPage={this.state.popupOptions.mainView}
                  templateSurveySwitch={this.templateSurveySwitch}
                  turnOffMainView={this.turnOffMainView}
                  searchKey={this.state.searchKey}
                  user={this.props.user}
                  loadingCreateSurvey={this.props.loading}
                />
              ) : (
                <CreateFromDraft
                  user={this.props.user}
                  drafts={this.props.drafts}
                  getDrafts={this.props.getDrafts}
                />
              )}
            </TemplateSurveyPopup>
          )}

          <ConfirmationPopup
            open={this.state.confirmationPopup}
            onClose={() => this.setState({ confirmationPopup: false })}
            title="Ready to publish your changes?"
            subtext="These changes will be reflected in your live Phonic survey."
            action={this.onSubmit}
          />
          <div>
            <div id="header" className="create-survey-tabs nomargin">
              <Tabs
                id="tabs"
                variant="scrollable"
                scrollButtons="auto"
                value={this.state.tab}
                onChange={this.changeTabs}
                TabIndicatorProps={{ style: { background: "#51a871" } }}
                style={{ width: "calc(100% - 420px)" }}
              >
                <Tab label="Questions" value="questions" />
                <Tab label="Appearance" value="appearance" />
                <Tab label="Settings" value="admin" />
              </Tabs>
              <div className="action-buttons">
                {this.props.loading && (
                  <div id="saving-spinner">
                    <ClipLoader size={16} style={{ color: "black" }} />
                    &nbsp;Saving
                  </div>
                )}
                {!this.props.loading && this.state.unpublishedChanges && (
                  <div id="unpublished-alert">
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                    <p>Unpublished changes</p>
                  </div>
                )}
                {this.props.estimatedCompletionTimeMinutes &&
                  this.props.estimatedCompletionTimeMinutes.lowerBound > 0 && (
                    <p id="duration-estimate">{this.formatDurationString()}</p>
                  )}
                <PreviewSettings
                  icon={<FontAwesomeIcon icon={faCog} />}
                  autoRefresh={this.state.autoRefresh}
                  toggleAutoRefresh={this.toggleAutoRefresh}
                  preview={this.state.preview}
                  setPreview={this.setPreview}
                  previewOptions={previewOptions}
                  exportQuestions={this.exportQuestions}
                />
                <Button
                  className="preview-outlined-button"
                  variant="outlined"
                  color="primary"
                  onClick={this.showPreview}
                >
                  <FontAwesomeIcon icon={faEye} />
                  &nbsp;Preview
                </Button>
                <Button
                  id="publish-button"
                  variant="contained"
                  color="primary"
                  onClick={() => this.setState({ confirmationPopup: true })}
                >
                  {!this.state.publishPending ? (
                    <>
                      <FontAwesomeIcon icon={faCheck} />
                      &nbsp;Publish{" "}
                    </>
                  ) : (
                    <CircularProgress size={22} style={{ color: "white" }} />
                  )}
                </Button>
              </div>
            </div>

            {!this.props.currentSurvey ? (
              <div className="loader-container">
                {this.props.match.params.surveyId && (
                  <ScaleLoader size={"30px"} color={"#62cb88"} loading={true} />
                )}
              </div>
            ) : (
              <div>
                <div className={settingsClass}>
                  <SurveySettings
                    info={this.state.info}
                    surveyId={this.state.surveyId}
                    tier={this.props.user ? this.props.user.tier : "FREE"}
                    changeDemo={this.changeDemo}
                    changeInfo={this.changeInfo}
                    pushSurveyUpdates={this.pushSurveyUpdates}
                  />
                </div>
                <div className={editorClass}>
                  <Grid container>
                    <Grid item xs={12} sm={5} id="editor">
                      <div className={questionsClass}>
                        <SurveyItems
                          submit={this.submit}
                          questions={this.state.info.questions}
                          questionGroups={this.state.info.questionGroups}
                          changeInfo={this.changeInfo}
                          selectedQuestionId={this.state.selectedQuestionId}
                          questionFocusOverride={
                            this.state.questionFocusOverride
                          }
                          tier={this.props.user ? this.props.user.tier : "FREE"}
                          surveyId={this.state.surveyId}
                          info={this.state.info}
                          modFunctions={this.modFunctions}
                        />
                      </div>
                      <div className={appearanceClass}>
                        <SurveyAppearance
                          survey={this.state.info}
                          surveyId={this.state.surveyId}
                          changeInfo={this.changeInfo}
                          pushSurveyUpdates={this.pushSurveyUpdates}
                          user={this.props.user}
                        />
                      </div>
                    </Grid>
                    <Grid
                      item
                      sm={showConfigPane ? 4 : 7}
                      xl={showConfigPane ? 5 : 7}
                      id="viewer"
                    >
                      {this.state.info._id &&
                        this.state.preview === "default" && (
                          <iframe
                            key={this.state.previewId}
                            id="preview"
                            src={`${BASE_URL}/${
                              this.state.info._id
                            }?preview=true&staging=true&page=${
                              this.state.previewQuestionIdx === 0
                                ? 0
                                : this.state.previewQuestionIdx || -1
                            }`}
                            allow="microphone;camera"
                            title="survey preview"
                          ></iframe>
                        )}
                      <Paper
                        className={clsx(
                          "share-preview",
                          "builder",
                          this.state.preview === "default" && "hidden"
                        )}
                      >
                        <EmbedPreview
                          embedCode={
                            this.state.preview !== "default"
                              ? getEmbedJSX({
                                  phonicEmbed: this.state.preview,
                                  surveyId: this.state.surveyId,
                                  color: "#62cb88",
                                  helperText: "",
                                  page: this.state.previewQuestionIdx,
                                  preview: true,
                                })
                              : ""
                          }
                          embed={this.state.preview}
                        />
                      </Paper>
                    </Grid>
                    {showConfigPane && (
                      <Grid item xs={12} sm={3} xl={2}>
                        <QuestionConfiguration
                          surveyInfo={this.state.info}
                          changeQInfo={this.changeQInfo}
                          changeInfo={this.changeInfo}
                          id={this.state.selectedQuestionId}
                          qinfo={selectedQuestion}
                          closeQuestionConfig={() => this.closeQuestionConfig()}
                          tier={this.props.user ? this.props.user.tier : "FREE"}
                        />
                      </Grid>
                    )}
                  </Grid>
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateSurvey);
